const BASE_URL = 'states'

export default {
  GET_STATE: `/${BASE_URL}`,
  GET_STATES: `/${BASE_URL}`,
}
